import { CLEAR_FORM } from "../../utils/const"

const clearForm = () => {

    return {
        type: CLEAR_FORM
    }
}

export default clearForm
